import React, { createContext, useContext, useState, useCallback, useRef, useEffect } from 'react'

interface LiveTipsContextType {
  /** Whether there are unseen new tips */
  hasNewTips: boolean
  /** Mark tips as seen (clear the badge) */
  markTipsSeen: () => void
  /** Called when a new tip arrives via WebSocket */
  notifyNewTip: () => void
  /** WebSocket connection state */
  wsConnected: boolean
  setWsConnected: (connected: boolean) => void
}

const LiveTipsContext = createContext<LiveTipsContextType | undefined>(undefined)

export function LiveTipsProvider({ children }: { children: React.ReactNode }) {
  const [hasNewTips, setHasNewTips] = useState(false)
  const [wsConnected, setWsConnected] = useState(false)

  const markTipsSeen = useCallback(() => {
    setHasNewTips(false)
  }, [])

  const notifyNewTip = useCallback(() => {
    setHasNewTips(true)
  }, [])

  return (
    <LiveTipsContext.Provider
      value={{
        hasNewTips,
        markTipsSeen,
        notifyNewTip,
        wsConnected,
        setWsConnected,
      }}
    >
      {children}
    </LiveTipsContext.Provider>
  )
}

export function useLiveTipsNotification() {
  const context = useContext(LiveTipsContext)
  if (!context) {
    throw new Error('useLiveTipsNotification must be used within LiveTipsProvider')
  }
  return context
}
